import { render, staticRenderFns } from "./SelectableCard.vue?vue&type=template&id=1c710af2&"
import script from "./SelectableCard.vue?vue&type=script&lang=ts&"
export * from "./SelectableCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports